import { render, staticRenderFns } from "./NewCampaign.vue?vue&type=template&id=5bb3d15c&scoped=true&"
import script from "./NewCampaign.vue?vue&type=script&lang=js&"
export * from "./NewCampaign.vue?vue&type=script&lang=js&"
import style0 from "./NewCampaign.vue?vue&type=style&index=0&id=5bb3d15c&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb3d15c",
  null
  
)

export default component.exports